import styled from '@emotion/styled'
import React from 'react'

import { getColor } from '../../Theme'

export type TabMenuOption = 'main' | 'secondary'

type Props = {
  variant: TabMenuOption
  active: boolean
  buttonText: string
  onChange: (menu: TabMenuOption) => void
}

const TabsButton = styled.button<{ active: boolean; variant: TabMenuOption }>`
  flex: 1;
  font: inherit;
  text-align: center;
  padding: 12px 16px;
  cursor: pointer;
  background: ${(p) => (p.active ? 'transparent' : getColor(p.theme, ['grayLight'], ['grayDark']))};
  color: ${(p) => getColor(p.theme, ['black'], ['white'])};
  border-style: solid;
  z-index: 20;
  border-width: 1px;
  border-top-color: ${(p) =>
    p.active
      ? p.variant === 'main'
        ? getColor(p.theme, ['primaryGreen'], ['transparent'])
        : getColor(p.theme, ['primaryBlue'], ['transparent'])
      : 'transparent'};
  border-bottom-color: ${(p) =>
    !p.active
      ? p.variant === 'main'
        ? getColor(p.theme, ['primaryBlue'], ['transparent'])
        : getColor(p.theme, ['primaryGreen'], ['transparent'])
      : 'transparent'};
  border-left-color: ${(p) =>
    p.active && p.variant === 'secondary'
      ? getColor(p.theme, ['primaryBlue'], ['transparent'])
      : p.active && p.variant === 'main'
      ? 'transparent'
      : 'transparent'};
  border-right-color: ${(p) =>
    p.active && p.variant === 'main'
      ? getColor(p.theme, ['primaryGreen'], ['transparent'])
      : p.active && p.variant === 'secondary'
      ? 'transparent'
      : 'transparent'};
  box-sizing: border-box;
`

export const TabsMenuButton: React.FC<Props> = ({ variant, active, onChange, buttonText }) => {
  return (
    <TabsButton variant={variant} active={active} onClick={() => onChange(variant)}>
      {buttonText}
    </TabsButton>
  )
}
